<template>
  <el-container class="wrapper">
    <el-header height="80px" style="background-color:#409eff">
      <div class="header-nav flex flex-between">
        <div class="header-logo">
      <span>
        Element-UI-Theme
      </span>
        </div>
        <ul class="header-operations">
          <!--          <li @click="showHelpDialog">{{ langConfig.header.help[lang] }}</li>-->
          <li class="select-version select-init">
            {{ langConfig.header.versionName[lang] }}:
            <el-select filterable v-model="elementVersion" placeholder="请选择版本" @change="handleElement">
              <el-option v-for="(item,index) in versionOptions" :key="index" :label="item" :value="item"/>
            </el-select>
          </li>
          <li>
          <span @click="switchLang('/zh-CN')" :class="{ 'is-active': lang === '/zh-CN' }"
                class="header-lang">中文</span>
            <span>/</span>
            <span @click="switchLang('/en-US')" :class="{ 'is-active': lang === '/en-US' }"
                  class="header-lang">En</span>
          </li>
        </ul>
      </div>
    </el-header>
    <el-container class="container-body">
      <el-main class="content">
        <div v-for="(item,index) in components" :key="index" class="item-card">
          <p class="body-title" :id="item.title">{{ item.title }}</p>
          <component :is="item.component" :data="item" :originalStyle.sync="originalStyle"/>
        </div>
      </el-main>
      <el-aside class="menu">
        <div class="menu-header flex flex-between">
          <div class="btn-revoke visibility-hidden" :title="langConfig.menu.revoke[lang]" @click="onRevokeClick">
            <img src="@/assets/refresh-left.svg" alt=""/>
          </div>
          <div class="button-group btn-init">
            <el-button type="primary" plain round @click="onResetClick">{{ langConfig.menu.reset[lang] }}</el-button>
            <el-button type="primary" round @click="downloadZip">{{ langConfig.menu.download[lang] }}</el-button>
          </div>
        </div>
        <div class="menu-body">
          <div class="select-component select-init">
            <el-select filterable v-model="componentName" placeholder="请选择组件" @change="onSelectComponent">
              <el-option v-for="(item,index) in componentNameList" :key="index" :label="item.label"
                         :value="item.value"/>
            </el-select>
          </div>
          <component :ref="thisComponentsSetUp.title"
                     v-if="thisComponentsSetUp" :is="thisComponentsSetUp.component"
                     :data="thisComponentsSetUp" :originalStyle.sync="originalStyle" :lang="lang"/>
        </div>
      </el-aside>
    </el-container>
    <footer class="page-footer">
      <div class="text-center">
        <span class="margin-right-8">Copyright © 2024 菜鸟阿奇</span>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案：桂ICP备2021007231号</a>
        <span class="margin-left-8">声明：本站点非任何平台官网，仅用于Element UI主题样式制定</span>
      </div>
    </footer>
    <el-dialog :visible.sync="helpDialogVisible" :title="langConfig.help.title[lang]">
      <div v-html="langConfig.help.content[lang]" class="help"></div>
      <span slot="footer" class="dialog-footer btn-init">
        <el-button type="primary" @click="helpDialogVisible = false">{{ langConfig.help.ok[lang] }}</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import blobUtil from 'blob-util'
import langConfig from '@/lang'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import { use } from 'element-ui/lib/locale'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import enLocale from 'element-ui/lib/locale/lang/en'
import { stylePatch } from '@/utils/stylePatch'

import { getThemeColor, updateStyle } from '@/utils/common'
import versions from '@/utils/versions.json'

export default {
  name: 'home',
  data () {
    const colorValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.langConfig.validate.required[this.lang]))
      } else if (!/^#[\dabcdef]{6}$/i.test(value)) {
        return callback(new Error(this.langConfig.validate.format[this.lang]))
      } else {
        callback()
      }
    }
    return {
      colors: {
        primary: '#409eff'
      },
      rules: {
        primary: [
          { validator: colorValidator, trigger: 'blur' }
        ]
      },
      originalStylesheetCount: -1,
      originalStyle: '',
      downloadStyle: '',
      langConfig,
      primaryColor: '#409eff',
      themeDialogVisible: false,
      helpDialogVisible: false,
      zip: null,
      styleFiles: [],
      fontFiles: ['element-icons.ttf', 'element-icons.woff'],
      fonts: [],
      canDownload: false,
      query: {
        name: '',
        date: []
      },
      elementVersion: '',
      versionOptions: [],
      components: [],
      componentsSetUp: [],
      thisComponentsSetUp: null,
      componentNameList: [],
      componentName: 'Color',
      filterSetUpComponents: ['Typography']
    }
  },
  computed: {
    lang () {
      const lang = this.$route.path
      use(lang === '/zh-CN' ? zhLocale : enLocale)
      this.query.date = []
      return lang
    }
  },
  methods: {
    switchLang (lang) {
      this.$router.push(lang)
    },
    showThemeDialog () {
      this.themeDialogVisible = true
    },
    showHelpDialog () {
      this.helpDialogVisible = true
    },
    resetZip () {
      this.zip = new JSZip()
      this.fonts.forEach((font, index) => {
        this.zip.file(`fonts/${this.fontFiles[index]}`, font.data)
      })
    },
    downloadZip () {
      this.resetZip()
      const themeJson = blobUtil.createBlob([JSON.stringify(getThemeColor(this.downloadStyle))], { type: 'application/json' })
      const downloadStyle = blobUtil.createBlob([this.downloadStyle], { type: 'text/css' })
      this.zip.file('element-theme.css', downloadStyle)
      this.zip.file('theme-color.json', themeJson)
      this.zip.generateAsync({ type: 'blob' }).then(blob => {
        FileSaver.saveAs(blob, `element-theme-${this.elementVersion}.zip`)
      })
    },

    resetForm () {
      this.$refs.form.resetFields()
    },

    getFile (url, isBlob = false) {
      return new Promise((resolve, reject) => {
        const client = new XMLHttpRequest()
        client.responseType = isBlob ? 'blob' : ''
        client.onreadystatechange = () => {
          if (client.readyState !== 4) {
            return
          }
          if (client.status === 200) {
            const urlArr = client.responseURL.split('/')
            resolve({
              data: client.response,
              url: urlArr[urlArr.length - 1]
            })
          } else {
            reject(new Error(client.statusText))
          }
        }
        url = url.toString().replace('element-ui', `element-ui@${this.elementVersion}`)
        client.open('GET', url)
        client.send()
      })
    },

    getIndexStyle () {
      this.getFile('//unpkg.com/element-ui/lib/theme-chalk/index.css')
          .then(({ data }) => {
            let styleData = sessionStorage.getItem('originalStyle')
            if (!styleData) {
              sessionStorage.setItem('originalStyle', data)
            }
            this.originalStyle = data
          })
    },

    getSeparatedStyles () {
      this.getFile('//unpkg.com/element-ui/lib/theme-chalk/')
          .then(({ data }) => {
            return data.match(/href="[\w-]+\.css"/g).map(str => str.split('"')[1])
          })
          .then(styleFiles => {
            return Promise.all(styleFiles.map(file => {
              return this.getFile(`//unpkg.com/element-ui/lib/theme-chalk/${file}`)
            }))
          })
          .then(files => {
            this.styleFiles = files.map(file => {
              return {
                name: file.url,
                data: file.data
              }
            })
          })
    },

    getFontFiles () {
      Promise.all(this.fontFiles.map(font => {
        return this.getFile(`//unpkg.com/element-ui/lib/theme-chalk/fonts/${font}`, true)
      }))
          .then(fonts => {
            this.fonts = fonts
          })
    },
    async handleElement () {
      this.getIndexStyle()
      this.getSeparatedStyles()
      this.getFontFiles()
    },
    onSelectComponent (e) {
      let find = this.componentsSetUp.find(item => item.sortNumber === e)
      let find1 = this.componentNameList.find(item => item.value === e)
      if (find) {
        this.thisComponentsSetUp = find
      } else {
        this.thisComponentsSetUp = null
      }
      if (find1) {
        // window.location.hash = find1.label
      }
    },
    handleRenderingComponents () {
      const files = require.context('@/views/components', true, /\.vue$/)
      let components = files.keys().map((key, index) => {
        const regexFile = /\/([^/]+)\/index\.vue/
        const regexFile2 = /\/([^/]+)\/setUp\.vue/
        const numberRegex = /\/(\d+)\//
        let sortNumber = 0
        let path = key.match(regexFile)
        let path2 = key.match(regexFile2)
        const sortNum = key.match(numberRegex)
        let title = ''
        if (sortNum && sortNum.length) {
          sortNumber = Number(sortNum.pop())
        }
        if (path && path.length) {
          title = path.pop()
          if (index === 0 && !this.componentName.length) this.componentName = title
          if (!this.filterSetUpComponents.includes(title)) {
            this.componentNameList.push({ label: title, value: sortNumber })
          }
        } else if (path2 && path2.length) {
          title = path2.pop()
        }
        const component = files(key).default
        const result = { sortNumber, title, path: key, component }
        if (key.includes('/index.vue')) {
          result['main'] = component
        } else if (key.includes('/setUp.vue')) {
          result['menu'] = component
        }
        return result
      })
      components.forEach((item, index) => {
        if (item.hasOwnProperty('main')) {
          this.components.push(item)
        } else if (item.hasOwnProperty('menu')) {
          this.componentsSetUp.push(item)
          if (item.title === this.componentName) {
            this.thisComponentsSetUp = item
          }
        }
      })
      this.componentNameList = this.componentNameList.filter((item) => ['Color', 'Button'].includes(item.label))
      this.components.sort((a, b) => (a.sortNumber > b.sortNumber ? 1 : -1))
      this.componentNameList.sort((a, b) => (a.value > b.value ? 1 : -1))
      this.componentsSetUp.sort((a, b) => (a.sortNumber > b.sortNumber ? 1 : -1))
    },
    onResetClick () {
      this.$confirm('是否确定放弃当前已经修改的所有样式?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'btn-init',
        type: 'warning'
      }).then(() => {
        let cssText = sessionStorage.getItem('originalStyle')
        cssText = stylePatch(cssText)
        this.originalStyle = cssText
        updateStyle(cssText)
      }).catch(() => {})
    },
    onRevokeClick () {
      const that = this
      this.$nextTick(() => {
        let thisComponent = that.$refs[that.componentName]
        if (thisComponent) {
          thisComponent.onRevokeClick()
        }
      })
    }
  },
  created () {
    this.componentNameList = []
    let versionOptions = Object.keys(versions).reverse()
    this.versionOptions = versionOptions
    if (!this.elementVersion.length) {
      this.elementVersion = [].concat(versionOptions).shift()
    }
    let styleData = sessionStorage.getItem('originalStyle')
    if (styleData) {
      this.originalStyle = styleData
    } else {
      this.handleElement()
    }
    this.getFontFiles()
    this.handleRenderingComponents()
  },
  mounted () {
    this.$watch('originalStyle', (newVal) => {
      if (newVal) {
        this.downloadStyle = newVal
      }
    }, { deep: true, immediate: true })
    this.$nextTick(() => {
      this.originalStylesheetCount = document.styleSheets.length
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/index.vue